// extracted by mini-css-extract-plugin
module.exports = {"root":"OutlineButton-module--root--1KQ1l","dark":"OutlineButton-module--dark--19nVG"};